import {
  REQUIRED_PHONE_NUMBER_VALIDATOR,
  REQUIRED_TEXT_FIELD_VALIDATOR,
  TEXT_FIELD_VALIDATOR,
} from '@/helpers/formHelpers/validators';
import { USER_ROLE_LABEL_MAP, USER_ROLE_MAP } from './user';
import OrgAdminIcon from '@/images/OrgAdminIcon.svg?react';
import MasterAdminIcon from '@/images/MasterAdminIcon.svg?react';
import { object } from 'yup';

export type PersonalDetailsFormType = {
  first_name: string;
  middle_name: string;
  last_name: string;
};

export const PERSONAL_DETAILS_INITIAL_VALUES: PersonalDetailsFormType = {
  first_name: '',
  middle_name: '',
  last_name: '',
};

export const PERSONAL_DETAILS_VALIDATION_SCHEMA = object().shape({
  first_name: REQUIRED_TEXT_FIELD_VALIDATOR,
  middle_name: TEXT_FIELD_VALIDATOR,
  last_name: REQUIRED_TEXT_FIELD_VALIDATOR,
});

export const SELECT_ORGANIZATION_ADMIN_ROLE_RADIO_OPTIONS = [
  {
    value: USER_ROLE_MAP.ORG_ADMIN,
    label: USER_ROLE_LABEL_MAP[USER_ROLE_MAP.ORG_ADMIN],
    icon: <OrgAdminIcon />,
  },
  {
    value: USER_ROLE_MAP.MASTER_ADMIN,
    label: USER_ROLE_LABEL_MAP[USER_ROLE_MAP.MASTER_ADMIN],
    icon: <MasterAdminIcon />,
  },
];

export const MOBILE_PHONE_VALIDATION_SCHEMA = object().shape({
  mobile_phone: REQUIRED_PHONE_NUMBER_VALIDATOR,
});
